import { render, staticRenderFns } from "./ReporterWidget.vue?vue&type=template&id=68986497&scoped=true"
import script from "./ReporterWidget.vue?vue&type=script&lang=js"
export * from "./ReporterWidget.vue?vue&type=script&lang=js"
import style0 from "./ReporterWidget.vue?vue&type=style&index=0&id=68986497&prod&lang=scss&scoped=true"
import style1 from "./ReporterWidget.vue?vue&type=style&index=1&id=68986497&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68986497",
  null
  
)

export default component.exports